module.exports = __webpack_public_path__ + "static/media/ico_compromiso_new.cea74af1.svg";